import { experimentalQueryPersister } from '@lidea/shared/data-access/core';
import { queryOptions } from '@tanstack/react-query';

import { zoningApi } from '../apis/zoning-api';

export const heatmapKeys = {
  imageryIndexes: () =>
    queryOptions({
      queryKey: ['imageryIndexes'],
      queryFn: () => zoningApi.getImageryIndexes(),
      persister: experimentalQueryPersister('imageryIndexes'),
    }),
  all: () => ['heatmaps'],
  plotHeatmaps: (params: { plotId: number; imageryIndex?: string }) =>
    queryOptions({
      queryKey: [...heatmapKeys.all(), 'plots', params],
      queryFn: () =>
        zoningApi.getHeatmaps({
          plotId: params.plotId,
          imageryIndex: params.imageryIndex || '',
        }),
      persister: experimentalQueryPersister('plotHeatmaps'),
    }),
};
